import { Link } from "react-router-dom";

import { formatXOF } from "@/lib/format";

export type StickyCartBarAction =
  | { type: "link"; href: string }
  | { type: "submit"; formId: string; disabled?: boolean };

export interface StickyCartBarProps {
  totalMinor: number;
  label: string;
  action: StickyCartBarAction;
}

/**
 * Barre basse collante, mobile uniquement (`< lg`, VVS_MODELE_RESPONSIVE.md
 * §7.4). Porté depuis apps/web/components/cart/StickyCartBar.tsx — seul
 * changement : `next/link` → `react-router-dom` `Link` (`href` → `to`).
 */
export function StickyCartBar({ totalMinor, label, action }: StickyCartBarProps) {
  const content = (
    <>
      <span className="text-sm text-cream/80">Total</span>
      <span className="text-base font-semibold">{formatXOF(totalMinor)}</span>
      <span className="ml-auto text-sm font-medium uppercase tracking-wide">{label}</span>
    </>
  );

  const barClasses =
    "fixed inset-x-0 bottom-0 z-30 flex items-center gap-3 border-t border-navy3 bg-navy px-4 py-3 text-cream shadow-[0_-2px_8px_rgba(0,0,0,0.15)] lg:hidden";

  if (action.type === "link") {
    return (
      <Link to={action.href} className={barClasses}>
        {content}
      </Link>
    );
  }

  return (
    <button type="submit" form={action.formId} disabled={action.disabled} className={`${barClasses} disabled:opacity-60`}>
      {content}
    </button>
  );
}
